<template>
  <div v-show="visibility" class="-grid-cell-component">
    <cell-label
      v-show="!editable"
      :value="inputValue"
    />
    <div
      v-show="editable"
      class="-grid-cell-range-date-picker -grid-cell-component"
      style="width: 100%"
    >
      <sui-text-field
        ref="input"
        class="-grid-cell-range-date-picker__input"
        :class="inputClass()"
        :value="inputValue"
        :disabled="disabled"
        :mask="'####-##-##~####-##-##'"
        @blur="inputBlurred"
      />
      <span
        class="-grid-cell-range-date-picker__icon"
        :class="iconClass()"
        @click.stop="activate"
      />
    </div>
  </div>
</template>

<script>
import CellLabel from '../CellLabel/CellLabelView';

export default {
  name: 'GridCellRangeDatePicker',
  components: {
    'cell-label': CellLabel,
  },
  props: {
    checkEditableFunction: {
      type: Function,
      default: null,
    },
    checkDisabledFunction: {
      type: Function,
      default: null,
    },
    checkVisibilityFunction: {
      type: Function,
      default: null,
    },
    value: { type: [String, Date], default: '' }, // 부모로부터 입력 받은 날짜
    disabledDates: {
      type: [String, Object],
      default: null,
    },
  },
  data() {
    return {
      editable: true,
      disabled: false,
      visibility: true,
      inputValue: this.value,
      portalComponent: null,
      portal: null,
      activated: false,
      eventBindedElements: [],
    };
  },
  mounted() {},
  beforeDestroy() {
    this.deactivate();
    this.handleBeforeDestroy();
  },
  methods: {
    setEditable(rowData, columnName, dataset, grid) {
      if (this.checkEditableFunction) {
        this.editable = this.checkEditableFunction(rowData, columnName, dataset, grid);
      }
    },
    setDisabled(rowData, columnName, dataset, grid) {
      if (this.checkDisabledFunction) {
        this.disabled = this.checkDisabledFunction(rowData, columnName, dataset, grid);
      }
    },
    setVisibility(rowData, columnName, dataset, grid) {
      if (this.checkVisibilityFunction) {
        this.visibility = this.checkVisibilityFunction(rowData, columnName, dataset, grid);
      }
    },
    handleBeforeDestroy() {
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },
    inputClass() {
      // return 'vdp-datepicker input';
    },
    iconClass() {
      return 'vdp-datepicker__calendar-button';
    },
    activate() {
      if (this.disabled || this.isInline || this.readonly) {
        return;
      }
      if (this.activated) {
        this.deactivate();
        return;
      }
      this.activated = true;
      this.portal = this.getPortalComponent();
      this.portal.show(this.inputValue, this.$el, {
      });
      this.bindEvents(this.portal);
    },
    deactivate() {
      if (this.disabled) {
        return;
      }
      if (!this.activated) {
        return;
      }
      this.activated = false;
      if (this.isPopup) {
        this.close();
      } else if (this.portal) {
        this.unbindEvents(this.portal);
        this.portal.deactivate();
        this.portal = null;
      }
    },
    getPortalComponent() {
      if (!this.portalComponent) {
        const propsData = {
          value: this.value,
          isPopup: true,
        };
        const componentName = 'sui-range-date-picker';
        const componentInstance = utils.createPortalComponent(componentName, propsData);
        this.portalComponent = componentInstance;
      }
      return this.portalComponent;
    },
    bindEvents(portal) {
      if (!portal) {
        return;
      }
      portal.$on('confirm', this.onConfirm);
      document.addEventListener('mousedown', this.onDocumentMouseDown, true);
      let { pEl } = this.$el.parentElement;
      while (pEl) {
        this.eventBindedElements.push(pEl);
        pEl.addEventListener('scroll', this.deactivate);
        pEl = pEl.parentElement;
      }
    },
    unbindEvents(portal) {
      portal.$off('confirm', this.onConfirm);
      document.removeEventListener('mousedown', this.onDocumentMouseDown, true);
      this.eventBindedElements.forEach(element => {
        element.removeEventListener('scroll', this.deactivate);
      });
      this.eventBindedElements = [];
    },
    onDocumentMouseDown(e) {
      if (!this.portal) {
        this.deactivate();
        return;
      }
      if (!this.$el.contains(e.target) && !this.portal.$el.contains(e.target)) {
        this.deactivate();
      }
    },
    onConfirm(value) {
      this.setDateStr(value);
      this.deactivate();
      this.$emit('confirm', value);
    },
    setDateStr(value) {
      this.inputValue = value;
    },
    isValidRangeStr(str) {
      let isValid = false;
      const separator = '~';
      const splitted = str.split(separator);

      if (str === '') {
        isValid = true;
      } else if (splitted.length === 2) {
        const from = splitted[0];
        const to = splitted[1];
        if (moment(from).isValid() && moment(to).isValid()) {
          isValid = true;
        }
      }
      return isValid;
    },
    inputBlurred() {
      const textFieldValue = this.$refs.input.txtField;
      if (this.isValidRangeStr(textFieldValue)) {
        if (this.inputValue !== textFieldValue) {
          this.deactivate();
          this.$emit('confirm', textFieldValue);
        }
      } else {
        this.$refs.input.inputText(this.inputValue);
      }
    },
  },
};
</script>

<style scoped>
</style>
